import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Radar } from "lucide-react";
import axios, { API } from "@/lib/apiClient";
import { ScoreGauge } from "../components/ScoreGauge";

export const Share = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/public/audits/${id}`)
      .then((res) => setData(res.data))
      .catch(() => setData({ locked: true }));
  }, [id]);

  if (!data) {
    return <div className="flex min-h-[60vh] items-center justify-center"><div className="h-8 w-8 animate-spin rounded-full border-2 border-sovereign border-t-transparent" /></div>;
  }

  return (
    <div className="mx-auto max-w-lg px-6 py-20 text-center" data-testid="share-page">
      <div className="mb-6 flex items-center justify-center gap-2 text-sovereign">
        <Radar className="h-5 w-5" /> <span className="text-xs font-bold uppercase tracking-widest">BrandSignal Pulse Check</span>
      </div>
      <h1 className="mb-8 font-heading text-2xl font-bold text-white" data-testid="share-brand-name">{data.brand_name}</h1>
      {data.locked ? (
        <p className="text-slate-500" data-testid="share-locked-message">This audit isn't ready to share yet.</p>
      ) : (
        <div className="space-y-6">
          <div className="flex justify-center">
            <ScoreGauge score={data.visibility_score ?? 0} />
          </div>
          <div className="rounded-lg border border-sovereign/30 bg-sovereign/5 p-6" data-testid="share-teaser">
            <p className="mb-2 text-sm font-semibold text-sovereign">
              {data.hallucination_count} Hallucination Warning{data.hallucination_count === 1 ? "" : "s"} detected
            </p>
            {data.teaser && (
              <p className="text-sm text-slate-400">
                &ldquo;{data.teaser}&rdquo; <span className="text-slate-600">(sign in as the owner to see the full breakdown)</span>
              </p>
            )}
          </div>
          <a href="/" className="text-sm text-sovereign underline" data-testid="share-run-your-own-link">Run your own free BrandSignal audit</a>
        </div>
      )}
    </div>
  );
};
